import baseStore from '../generic_store'
import Axios from "axios";
import store from "../index";

const base = baseStore('files');

const state = {
    ...base.state,
    base_url: '/api/files',
    resourceName: 'Fichier',
    model: {},
    isUploadPending: false,
};

const getters = {
    ...base.getters,
    files(state) {
        return state.list.filter( file => file.file !== null);
    },
    thumb(state) {
        return state.list.filter( file => file.thumb !== null)[0];
    }
};

const mutations = {
    ...base.mutations,
};

const actions = {
    ...base.actions,
    upload({state, dispatch, commit}, {files = [], removes = [], includes = [], domain_id = 1}) {
        state.isUploadPending = true;

        return Axios.post(`${store.getters['config/app_url']}${state.base_url}/upload?&translatable=1${ (includes.length > 0 ? ('&include=' + includes.join(',')) : '')}&filter[domain_id]=${domain_id}`, {files: files, removes: removes, domain_id: domain_id},
            {
                headers: {
                    //'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').attributes.content.value
                    'X-XSRF-TOKEN': $cookies.get('XSRF-TOKEN')
                }
            })
            .then(response => {
                dispatch('modals/close', null, {root: true})
                dispatch('toasts/add', {type: 'success', message: removes.length > 0 ? 'Files deleted' : 'Files uploaded'}, {root: true})
                commit('SET_LIST', response.data.data)
            })
            .catch(error => {
                console.warn(error);
                if (error.status === 422) {
                    commit('SET_ERRORS', error.data.errors);
                }
            })
            .finally(() => {
                state.isUploadPending = false;
            })
    },
    delete({state, dispatch, commit}, {uuid}) {
        return Axios.delete(`${store.getters['config/app_url']}${state.base_url}`, {
            data: {
                uuid: uuid
            }
        })
        .then(response => {
            dispatch('toasts/add', {type: 'success', message: 'File deleted'}, {root: true})
        })
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
